import { useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import React from 'react';
import axios from 'axios';
import { Config } from 'config/envConfig';
import { ConfirmModal } from '@quyva/shared-ui';
import { getUrl } from '../components/pdfDisplay/utils';

const NODE_URL = getUrl(
    `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}`
);

function fmtTime(iso) {
    return new Date(iso).toLocaleString('en-IN', {
        timeZone: 'Asia/Kolkata',
        dateStyle: 'medium',
        timeStyle: 'short',
    }) + ' IST';
}

// Returns { warnIfNeeded, WarningModal }
// warnIfNeeded(taskName, onProceed) — checks if maintenance is scheduled within 1 hour.
// If so, renders a ConfirmModal (via portal) asking the user to confirm before proceeding.
// If not, calls onProceed() immediately.
// Render {WarningModal} anywhere in the component's JSX (portal, so position doesn't matter).
export function useMaintenanceWarning() {
    const [warningState, setWarningState] = useState(null);

    const warnIfNeeded = useCallback(async (taskName, onProceed) => {
        try {
            const user = JSON.parse(localStorage.getItem('current'));
            const token = encodeURIComponent(user?.token || '');
            const res = await axios.get(`${NODE_URL}/api/maintenance/status`, {
                headers: { Authorization: token },
            });
            const schedule = res.data?.data?.schedule;
            if (schedule && schedule.status === 'scheduled') {
                const msToStart = new Date(schedule.maintenanceStart) - Date.now();
                if (msToStart > 0 && msToStart <= 60 * 60 * 1000) {
                    setWarningState({ taskName, onConfirm: onProceed, schedule });
                    return;
                }
            }
        } catch {
            // Status check failed — don't block the task
        }
        onProceed();
    }, []);

    const dismiss = useCallback(() => setWarningState(null), []);

    const WarningModal = warningState
        ? ReactDOM.createPortal(
              React.createElement(ConfirmModal, {
                  modalText: `Maintenance is scheduled at ${fmtTime(warningState.schedule.maintenanceStart)} — less than an hour away. Your ${warningState.taskName} may be interrupted. Do you want to proceed?`,
                  onConfirm: () => { dismiss(); warningState.onConfirm(); },
                  onCancel: dismiss,
                  confirmText: 'Proceed Anyway',
                  cancelText: 'Cancel',
              }),
              document.body
          )
        : null;

    return { warnIfNeeded, WarningModal };
}
